import styled from 'styled-components'

export default styled.div`
  box-sizing: border-box;
  color: ${props => props.theme.colors.text};
  height: 100%;
  padding: 15px 40px;
  max-width: 1440px;
  margin: 0 auto;
  min-height: 100vh;
`
